import { Check, X } from "lucide-react";

export default function AnswerPhase({
  onCorrect,
  onIncorrect,
}) {
  return (
    <div className="answer-phase">

      <div className="answer-phase__actions">
        <button className="answer-phase__button answer-phase__button--incorrect" onClick={onIncorrect}>
          <X size={32} strokeWidth={3} />
        </button>
        <button className="answer-phase__button answer-phase__button--correct" onClick={onCorrect}>
          <Check size={32} strokeWidth={3} />
        </button>
      </div>

    </div>
  );
}